/**
 * Enum representing application lifecycle and state events.
 *
 * Usage:
 *   Event.App.Pause
 *   Event.App.Resume
 *
 * These events are dispatched during app lifecycle changes
 * such as backgrounding, foregrounding, and activation states.
 *
 * @author Matt Kenefick <matt@polymermallard.com>
 * @package Event
 * @project ChalkySticks
 */
export enum App {
	Activate = 'activate',
	Deactivate = 'deactivate',
	Pause = 'app:pause',
	Resume = 'app:resume',
}
